'use client';

import React from 'react';
import { useScript } from '@app/scripts';
import NostoRecommendationsBlock from '@app/components/nosto/nosto-recommendations-block';
import cn from 'clsx';
import s from './collection-recommendations.module.css';

type CollectionRecommendationsProps = {
    collectionHandle: string;
    collectionTitle: string;
};

const CollectionRecommendationsAfterGrid = ({
    collectionHandle,
    collectionTitle,
}: CollectionRecommendationsProps) => {
    const { nostoInitialised } = useScript();
    if (!nostoInitialised) return null;
    return (
        <article className={cn(s.root, s.stack)}>
            <NostoRecommendationsBlock
                placementIdentifier="categorypage-nosto-1"
                pageKey={`product_${collectionHandle}`}
                id={collectionTitle}
                type="collection"
                customRootClass={s.recommendationsBlock}
                swiperType="product_card"
            />
            <NostoRecommendationsBlock
                placementIdentifier="categorypage-nosto-2"
                pageKey={`product_${collectionHandle}`}
                id={collectionTitle}
                type="collection"
                customRootClass={s.recommendationsBlock}
                swiperType="product_card"
            />
            <NostoRecommendationsBlock
                placementIdentifier="categorypage-nosto-3"
                pageKey={`product_${collectionHandle}`}
                id={collectionTitle}
                type="collection"
                customRootClass={s.recommendationsBlock}
                swiperType="product_card"
            />
        </article>
    );
};

export default CollectionRecommendationsAfterGrid;
